import { ThemeInterface, themeNames } from "../theme";
import { colors } from "../../styles/variables";
import { FontNames, HexColor, TextTransform } from "@pepdirect/shared/types";
type RockstarColorNames = "rockstarGold" | "black" | "background";

const ROCKSTAR_COLORS: Record<RockstarColorNames, HexColor> = {
  rockstarGold: "#CF9C43",
  black: "#000",
  background: "#000",
};

const SHARED_HEADING_STYLES = {
  color: ROCKSTAR_COLORS.black,
  fontFamily: "font-secondary" as FontNames,
  textTransform: "uppercase" as TextTransform,
};

export const RockstarEnergyTheme: ThemeInterface = {
  name: themeNames.RockstarEnergy,
  color: {
    primary: ROCKSTAR_COLORS.rockstarGold,
    secondary: ROCKSTAR_COLORS.rockstarGold,
    tertiary: ROCKSTAR_COLORS.black,
    accent: ROCKSTAR_COLORS.black,
    disabled: colors.gray,
    action: colors.green,
    error: colors.red,
    text: ROCKSTAR_COLORS.black,
  },
  button: {
    primary: {
      color: ROCKSTAR_COLORS.rockstarGold,
      textColor: ROCKSTAR_COLORS.black,
      solidOnHover: true,
    },
    secondary: {
      color: ROCKSTAR_COLORS.rockstarGold,
      textColor: ROCKSTAR_COLORS.black,
      solidOnHover: true,
    },
    tertiary: { color: ROCKSTAR_COLORS.black },
    cancel: { color: colors.mediumGray },
    error: { color: colors.red },
    text: { color: ROCKSTAR_COLORS.black },
    disabled: { hollow: true },
    fontFamily: "font-secondary",
    textTransform: "uppercase",
    borderRadius: "0",
  },
  typography: {
    heading: {
      xxl: {
        fontSize: {
          desktop: "44px",
          mobile: "36px",
        },
        ...SHARED_HEADING_STYLES,
      },
      xl: {
        fontSize: {
          desktop: "30px",
          mobile: "26px",
        },
        ...SHARED_HEADING_STYLES,
      },
      l: {
        fontSize: {
          desktop: "20px",
          mobile: "18px",
        },
        ...SHARED_HEADING_STYLES,
      },
      m: {
        fontSize: {
          desktop: "20px",
          mobile: "18px",
        },
        ...SHARED_HEADING_STYLES,
      },
      s: {
        fontSize: {
          desktop: "13px",
          mobile: "13px",
        },
        ...SHARED_HEADING_STYLES,
      },
      xs: {
        fontSize: {
          desktop: "13px",
          mobile: "13px",
        },
        ...SHARED_HEADING_STYLES,
      },
      xxs: {
        fontSize: {
          desktop: "13px",
          mobile: "13px",
        },
        fontWeight: "400",
        color: ROCKSTAR_COLORS.black,
      },
    },
  },
  header: {
    backgroundColor: ROCKSTAR_COLORS.black,
  },
  footer: {
    backgroundColor: ROCKSTAR_COLORS.black,
  },
};
